export default [{
        header: 'Panel',
    },
    {
        title: 'Management',
        route: 'management',
        icon: 'HomeIcon',
    },
    {
        title: 'Users',
        route: 'users',
        icon: 'UsersIcon',
    },
    {
        title: 'Catalog',
        icon: 'BookOpenIcon',
        children: [{
                title: 'Catalog Categories',
                route: 'catalog-categories'
            },
            {
                title: 'Catalog Sub Categories',
                route: 'catalog-sub-categories'
            },
            {
                title: 'Catalog Brands',
                route: 'catalog-brands'
            },
            {
                title: 'Catalog Products',
                route: 'catalog-products',
            },
        ],
    },
    {
        title: 'Categories',
        route: 'categories',
        icon: 'ListIcon',
    },
    {
        title: 'Contents',
        route: 'contents-categories',
        icon: 'ListIcon',
    },
    {
        title: 'Our Leaders',
        route: 'our-leaders',
        icon: 'ListIcon',
    },
    {
        title: 'Sliders',
        route: 'sliders-home',
        icon: 'ListIcon',
    },
    {
        title: 'Medias',
        route: 'medias',
        icon: 'FileIcon',
    },
    {
        title: 'Newsletters',
        route: 'newsletters',
        icon: 'MailIcon',
    },
    {
        title: 'Popups',
        route: 'popups',
        icon: 'MailIcon',
    },
    {
        title: 'Forms',
        icon: 'CopyIcon',
        children: [{
            title: 'Company Activities',
            icon: 'CopyIcon',
            route: 'forms-company-activities',
        }, {
            title: 'Explicit Consent Text Forms',
            icon: 'CopyIcon',
            route: 'forms-explicit-consent-texts'
        }],

    },
]